import { tConsultDetailModel } from './tConsultDetailModel';

export class tPrescriptionHeadModel {

    shopID: string;
    prescriptionNumber: string;
    prescriptionDate: Date;
    consultNumber: string;
    patientID: string;

    prescriptionItemType: number;


    prescriptionType: number;
    prescriptionStatus: string;

    feeItemCateID: string;
    feeItemCateName: string;
    feeItemID: string;
    feeItemDesc: string;
    feeAmt: number;

    prescriptionCateID: string;
    prescriptionCateName: string;
    prescriptionitemID: string;
    prescriptionitemDesc: string;
    prescriptionitemUnitAmt: number;
    prescriptionitemFinalUnitAmt: number;


    prescriptionDays: number;
    dailyTimes: number;
    prescriptionQuantity: number;

    takeMethod: string;
    diagonsis: string;

    remark1: string;

    remark2: string;
    remark3: string;
    remark4: string;
    remark5: string;


    InActive: string;
    LastModifyDatetime: Date;
    LastModifyUserID: string;

    tempTtlPack:number;
    tempPackPerTime:number;
    packingRaito:number;
    finalTtlPack:number;
    medicalOrder:string;
}

export class tPrescriptionHeadModelV2 extends tPrescriptionHeadModel{
  prescriptionFollowUpDesc:string;
}

export class tPrescriptionCopyHeadModel {

    shopID: string;
    prescriptionCopyNumber: string;
    prescriptionCopyDate: Date;


    prescriptionItemType: number;


    prescriptionType: number;
    prescriptionName: string;

    feeItemCateID: string;
    feeItemCateName: string;
    feeItemID: string;
    feeItemDesc: string;
    feeAmt: number;

    prescriptionCateID: string;
    prescriptionCateName: string;
    prescriptionitemID: string;
    prescriptionitemDesc: string;
    prescriptionitemUnitAmt: number;
    prescriptionitemFinalUnitAmt: number;


    prescriptionDays: number;
    dailyTimes: number;
    prescriptionQuantity: number;

    takeMethod: string;
    diagonsis: string;

    remark1: string;

    remark2: string;
    remark3: string;
    remark4: string;
    remark5: string;


    InActive: string;
    LastModifyDatetime: Date;
    LastModifyUserID: string;

    tempTtlPack:number;
    tempPackPerTime:number;
    packingRaito:number;
    finalTtlPack:number;
    medicalOrder:string;
}



export class tPrescriptionHeadModelWithPatientBPInfo extends tPrescriptionHeadModel {

    clthConsultNumber: string;


    patientID: string;
    patientTypeID: string;
    pTypeDesc: string;
    patientTitle: number;
    patientGender: number;
    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;
    phoneAreaCode: string;
    patientPhone: number;
    patientPhone2: number;
    patientMedCard1: string;
    patientMedCard2: string;
    patientIHKID: string;
    patientDob: Date;
    patientRefereeEmp: string;
    patientRefereePat: string;
    patientRefereeRelation: number;
    patientAddress: string;
    patientEmail: string;
    patientRemark1: string;
    patientRemark2: string;
    patientRemark3: string;
    patientDepositAcct: number;
    patientChangeAcct: number;

    patientKnowFromMedium: string;
    billRemaining: number;

    bpInvoiceNumber: string;

    clthBillingStatus: string;

    bpCount: number;

    tConsultDetailInfo: tConsultDetailModel[];

    clthDiagonsis: string;
    clthDetailDesc: string;
    clthFollowUpDesc: string;
    doctorName:string;
    doctorID:string;
}

export class tPrescriptionHeadModelWithPatientBPInfoV2 extends tPrescriptionHeadModelWithPatientBPInfo{
    bookingTime:string;
    clthCaseDrID:string;
}
export class tPrescriptionPickModelWithList extends tPrescriptionHeadModelWithPatientBPInfo{
    isPick:string;
}

export class tPrescriptionDirectionsModel {

    id:number;
    shopID:string;
    prescriptionType:number;
    presAdvice:string;
    presDirections:string;

    }


export class tCookingMethod {
  methodID: string;
  methodDesc: string;
  methodDescEng: string;
}
